import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FlagResponse } from '@models/flag-response';

@Injectable({
  providedIn: 'root',
})
export class FlagDataService {
  private flagDeatils: FlagResponse = {
    ach: false,
    bc: false,
    cc: false,
    doc: false,
    eft: false,
    isCCDC: false,
    lb: false,
    login: false,
    paper: false,
    pb: false,
    pc: false,
    pu: false,
    mileage: false,
    address: false,
    guest: false,
    mobile: false,
    openBay: false
  };
  private details = new BehaviorSubject<FlagResponse>(this.flagDeatils);
  $flagDeatils = this.details.asObservable();

  updateflagDetails(flagDeatils: FlagResponse) {
    this.details.next(flagDeatils);
  }

  clear() {
    this.details.next(null);
  }
}
